function initQuickSearch(tags, tag_operator, quick_search_id) {

    var course_api_url = getQuickSearchUrl(tags, tag_operator);

    $(document).ready(function() {
        $.ajax({
            method: "GET",
            url: course_api_url
        }).done(function (data){
            populateQuicksearchDropdown(data, quick_search_id);
        });
    });
}

function getQuickSearchUrl(tags, operator) {
    var tag_filters = tags.split(",");
    var courses_api_url = "/flinders-services/courses.json";
    var API_TAG_FILTERS_PARAMETER = "tagFilters.";
    var API_TAG_FILTERS_OPERATOR_PARAMETER = "tagFiltersOperator.";
    var suffix = "";
    if(tags !== "" && tag_filters.length > 0) {
        for (var i = 0; i < tag_filters.length; i++) {
            suffix+=API_TAG_FILTERS_PARAMETER + tag_filters[i]+".";
        }
        suffix += API_TAG_FILTERS_OPERATOR_PARAMETER + operator;
    }

    return courses_api_url+(suffix?("/"+suffix  + ".json"):"");
}

function populateQuicksearchDropdown(data, quick_search_id) {
    //TODO: Investigate using tags to define "known groups" so data can be grouped by something other than study type
    var STUDY_TYPE_PROPERTY = "studyTypes";
    var SHOW_RECENT_GROUP_NAME = "Recently viewed";
    var SHOW_RECENT_GROUP_KEY = "recentlyViewed";
    var dropdown_data = [];

    var course_groups = ["Undergraduate","Major","Honours","Graduate","Postgraduate","Research higher degree"];
    var non_course_groups = [];
    // var found_groups = [];
    var the_select_box = $("#"+quick_search_id);
    var select_box_parent = the_select_box.closest(".quicksearch");
    var midyear_svg = select_box_parent.find("#"+quick_search_id+"__midyear_icon");
    var show_satac_codes = (select_box_parent.data("show-satac-codes") === "yes");
    var show_cricos_codes = (select_box_parent.data("show-cricos-codes") === "yes");

    var show_recent = (select_box_parent.data("show-recent-items") === "yes");
    var recent_items_limit = parseInt(select_box_parent.data("recent-items-limit"));

    //Group data by study area
    //TODO: Might need to make this more generic if we wish to do custom groupings
    var grouped_courses = data.reduce(function (accumulator, course) {
        var course_study_types = course[STUDY_TYPE_PROPERTY];
        for(var i = 0; i < course_study_types.length; i++) {
            var key = course_study_types[i];
            if (!accumulator[key]) {
                accumulator[key] = [];
            }
            var group_id_to_append = key.replace(/\s+/g, '_').toLowerCase(); //Note: this converts "Research higher degree" to "research_higher_degree"
            accumulator[key].push(convertCourseObjectToSelect2(course, show_satac_codes, show_cricos_codes, group_id_to_append));
        }
        return accumulator;
    }, {});

    //Add the grouped courses data to the select2 data format
    for(var i = 0; i < course_groups.length; i++) {
        var current_group = course_groups[i];
        var group_object = {"text":"","children":[]};
        var current_group_courses = grouped_courses[current_group];
        group_object.text = current_group;
        if(current_group_courses != null && current_group_courses.length > 0) {
            group_object.children = current_group_courses;
            dropdown_data.push(group_object);
        }
    }

    if(show_recent) {
        non_course_groups.push(SHOW_RECENT_GROUP_NAME);
        var show_recent_group = loadSelect2ItemsFromLocalStorage(SHOW_RECENT_GROUP_NAME, SHOW_RECENT_GROUP_KEY, recent_items_limit);

        if(show_recent_group.children.length > 0) {
            dropdown_data.unshift(show_recent_group);
        }
    }

    //Init select2
    var placeholder_text = select_box_parent.data("placeholder-text");
    var max_height_class = select_box_parent.data("max-height-pixel-value");
    //TODO: Allow max results per category/group setting
    //var max_results_per_group = select_box_parent.data("max-results-per-category");
    var show_midyear_indicator = (select_box_parent.data("show-midyear-indicator") === "yes");

    var select2options = {
        width: '100%',
        placeholder: placeholder_text,
        theme: 'flinders',
        data: dropdown_data,
        allowClear: true,
        maximumSelectionLength: 1,
        dropdownCssClass: max_height_class,
        dropdownAutoWidth: false,
        escapeMarkup: function(markup) {
            return markup;
        },
        templateResult: function (item) {
            // No need to template the searching text
            if (item.loading) {
                return item.text;
            }
            var term = query.term || '';
            return markMatch(item, term, show_midyear_indicator, midyear_svg);
        },
        language: {
            searching: function (params) {
                query = params;
                return 'Searching…';
            },
            "noResults": function(){
                var term = query.term || '';

                return "No results found, try using our <a href='/search?q="+term+"'>website search</a>.";
            }
        }
    };
    renderSelect2Dropdown(the_select_box, select2options);

    //Note: these events are only defined once

    //Unbind mousewheel event, which allows the results to be scrolled
    the_select_box.on("select2:open", function(e) {
        var results_container = $("#select2-"+quick_search_id+"-results");
        results_container.off("mousewheel");
    });

    //Define what the url will be when a user clicks on an item
    var querystring_parameter = select_box_parent.data("query-parameter");
    var querystring_value = select_box_parent.data("query-value");
    var open_in_new_tab = (select_box_parent.data("open-in-new-tab") === "yes");

    the_select_box.on('select2:select', function (e) {
        var item_selected = e.params.data;
        var item_link = item_selected.strLink;
        if(querystring_parameter != null && querystring_value != null) {
            item_link = updateQueryStringParameter(item_link, querystring_parameter, querystring_value);
        }
        the_select_box.val(null).trigger('change'); //this line clears the selection from the input area

        if(show_recent) {
            saveSelect2ItemToLocalStorage(item_selected, SHOW_RECENT_GROUP_KEY);

            var show_recent_group = loadSelect2ItemsFromLocalStorage(SHOW_RECENT_GROUP_NAME, SHOW_RECENT_GROUP_KEY, recent_items_limit);

            if(show_recent_group.children.length > 0) {
                //Remove old recently viewed group
                dropdown_data = dropdown_data.filter(function( obj ) {
                    return obj.text !== SHOW_RECENT_GROUP_NAME;
                });
                dropdown_data.unshift(show_recent_group);

                select2options.data = dropdown_data;
                renderSelect2Dropdown(the_select_box, select2options);
                the_select_box.trigger('change');
            }
        }

        if(open_in_new_tab) {
            window.open(item_link, '_blank');
        } else {
            window.location = item_link;
        }
    });

    the_select_box.on('select2:opening', function (e) {
        var MIN_DROPDOWN_HEIGHT = 150;
        var SCROLL_DURATION = 500;

        var viewport_top = $(window).scrollTop();
        var selectbox_offset = the_select_box.offset().top;
        if(selectbox_offset - viewport_top > MIN_DROPDOWN_HEIGHT) {
            $.scrollTo(the_select_box.offset().top-MIN_DROPDOWN_HEIGHT, SCROLL_DURATION, {easing:'easeInOutExpo'});
        }
    });


    //TODO(JD): Perhaps we should decide on something more meaningful for this to do?
    select_box_parent.find(".quicksearch_icon").on("click", function(e) {
        e.preventDefault();
        the_select_box.select2('open');
    });
}

function renderSelect2Dropdown(base_element, select2options) {
    base_element.empty();
    base_element.select2(select2options);
    base_element.closest(".quicksearch").fadeIn();
}

//Persist recent selections into localStorage
function saveSelect2ItemToLocalStorage(item, group) {
    var MAX_GROUP_SIZE = 25; //NOTE: This could be any number within reason, 25 seems like a reasonable maximum to keep the size on the small side.
    var item_id_prefix = group+"_";
    var selected_item_id = item.id;
    //Check if it already has the prefix, probably because they clicked on an item in the recently viewed list.
    var has_prefix = selected_item_id.indexOf(item_id_prefix) === 0; //Specifically that the ID *starts* with the prefix, we don't care if it randomly occurs

    if(!has_prefix) {
        item.id = item_id_prefix + selected_item_id;
    }
    item.selected = false; //We have to set the item to not selected otherwise select2 will think it is selected!!

    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.quickSearchData = Object.assign({}, userProfile.quickSearchData);
    var quickSearchData = userProfile.quickSearchData;

    if(quickSearchData[group]) {
        //Filter out items with the same ID
        quickSearchData[group] = quickSearchData[group].filter(function( obj ) {
            return obj.id !== item.id;
        });
        quickSearchData[group].unshift(item);
        //Prevent the array of items from getting too big
        if(quickSearchData[group].length > MAX_GROUP_SIZE) {
            quickSearchData[group].length = MAX_GROUP_SIZE;
        }
    } else {
        quickSearchData[group] = [item];
    }

    setLocalStorageObject('userProfile', userProfile);
}

//Function will return items in the "group" format that select2 expects
function loadSelect2ItemsFromLocalStorage(group_name, group_key, limit) {
    //NOTE: Limit is only the display limit, the limit with regards to data storage is defined in code, not a component config.
    if(!limit) {
        limit = 5;
    }
    var group_object = {"text":group_name,"children":[]};
    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.quickSearchData = Object.assign({}, userProfile.quickSearchData);
    var quickSearchData = userProfile.quickSearchData;

    if(quickSearchData.hasOwnProperty(group_key)) {
        var group_items = userProfile.quickSearchData[group_key];

        if(group_items.length > 0) {
            if(limit) {
                group_object.children = group_items.splice(0, limit);
            } else {
                group_object.children = group_items;
            }
        }
    }

    return group_object;
}

//Select2 is fairly strict with its data structure.
function convertCourseObjectToSelect2(course, show_satac_codes, show_cricos_codes, group_id) {

    var converted_course_object = {"id":"","text":"","strLink":"","satac":"","cricos":"","midyear":""};
    var course_text = course.name;
    var satac_code = course.hasOwnProperty("satacCode") ? course.satacCode : "";
    var cricos_code = course.hasOwnProperty("cricosCode") ? course.cricosCode : "";
    var codes = [];

    converted_course_object["id"] = course.id.toString() + "_"+group_id;
    converted_course_object["strLink"] = course.strLink;
    converted_course_object["midyear"] = course.hasOwnProperty("midYearEntry") ? course.midYearEntry : false;

    if(show_satac_codes && satac_code) {
        converted_course_object["satac"] = satac_code;
        codes.push("SATAC: "+satac_code);
    }
    if(show_cricos_codes && cricos_code) {
        converted_course_object["cricos"] = cricos_code;
        codes.push("CRICOS: "+cricos_code);
    }
    if(codes.length > 0) {
        course_text += " — "+codes.join(", ");
    }
    converted_course_object["text"] = course_text;

    return converted_course_object;
}

//New version of select 2 does not make visually indicating the matches in the search results as obvious
//Note(JD): this only wraps the *first* matching term, not all matching terms. This provides almost all of the benefits with a greatly improved performance.
//TODO: Investigate methods of multi-highlighting that does not hurt performance with 400+ results.
function markMatch (item, term, show_midyear_indicator, midyear_svg) {
    var item_text = item.text;
    var $result = $('<span></span>');
    var midyear_icon = midyear_svg.html();
    var match = item_text.toUpperCase().indexOf(term.toUpperCase());

    if(match !== -1) {
        $result.html(item_text.substring(0, match)); //Append first part, before the match
        var $match = $('<mark class="select2-rendered__match"></mark>'); //Define the match wrapping class
        $match.html(item_text.substring(match, match + term.length)); //Insert the matching text into the wrapping class
        $result.append($match); //Append the wrapped term to the pre-term string
        $result.append(item_text.substring(match + term.length)); //Append everything after the match to the term.

    } else {
        $result.html(item_text);
    }

    if(show_midyear_indicator && item.midyear) {
        $result.append(midyear_icon);
    }

    return $result;
}
function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        return uri + separator + key + "=" + value;
    }
}

$(".append_query_string").on("click", function (e) {
    var button_clicked = $(this);
    var button_href = button_clicked.attr("href");
    var query_parameter_to_append = button_clicked.data("queryparameter");
    var query_parameter_to_append_alias = button_clicked.data("queryparameteralias");
    var query_parameter_value = getUrlParam(query_parameter_to_append);

    if(query_parameter_to_append_alias && query_parameter_to_append_alias.length > 0) {
        button_clicked.attr("href", updateQueryStringParameter(button_href, query_parameter_to_append_alias, query_parameter_value));
    } else {
        button_clicked.attr("href", updateQueryStringParameter(button_href, query_parameter_to_append, query_parameter_value));
    }
});
